// extracted by mini-css-extract-plugin
export default {"flex":"flex-6077","icon":"icon-8499","bold":"bold-d655","text-wrapper":"text-wrapper-39f1"};